/**
 * Simulación temporal Tiger — solo hosts allowlisteados (never enable in prod builds).
 * Activar: ?tigerSim=1 → queda en sessionStorage hasta ?tigerSim=0
 * OJO: no es el bridge nativo; sirve para validar login→exchange→/m/{opaque} en browser.
 *
 * Allowlist: localhost/127.0.0.1 + REACT_APP_TIGER_SIM_HOSTS (CSV). Sin DNS hardcode.
 */
const STORAGE_KEY = 'tigerSim';

/** Solo loopback en código. El resto vía REACT_APP_TIGER_SIM_HOSTS. */
const LOCAL_DEV_HOSTS = new Set(['localhost', '127.0.0.1']);

function tigerSimHostsFromEnv() {
  // DefinePlugin inyecta el literal; no guardar detrás de `process.env` (undefined en browser).
  const raw = String(process.env.REACT_APP_TIGER_SIM_HOSTS || '').trim();
  if (!raw) return [];
  return raw
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

function allowedTigerSimHosts() {
  return new Set([...LOCAL_DEV_HOSTS, ...tigerSimHostsFromEnv()]);
}

/** Kill-switch explícito (build arg / env). Hosts no listados ya quedan off. */
function isTigerSimDisabledByEnv() {
  const flag = String(process.env.REACT_APP_TIGER_SIM_DISABLED || '').trim().toLowerCase();
  return flag === '1' || flag === 'true';
}

function isLabHost() {
  if (isTigerSimDisabledByEnv()) return false;
  try {
    const h = String(window.location.hostname || '').toLowerCase();
    return allowedTigerSimHosts().has(h);
  } catch {
    return false;
  }
}

/** Persiste / limpia según query y reporta si el sim está activo. */
export function syncTigerSimFromUrl() {
  if (typeof window === 'undefined' || !isLabHost()) return false;
  try {
    const params = new URLSearchParams(window.location.search || '');
    const flag = params.get('tigerSim');
    if (flag === '1' || flag === 'true') {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } else if (flag === '0' || flag === 'false') {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
  return isTigerSimActive();
}

export function isTigerSimActive() {
  if (typeof window === 'undefined' || !isLabHost()) return false;
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
